<app-compliance-nav [activeMenuItem]="'ccedi'"></app-compliance-nav>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<mat-card class="content-card">

  <h3>💂‍♂️CardCompact Early Detect</h3>

  <div fxLayout="row" style="">
    <div fxFlex="30">
      <app-date-edit class="date-field"  (onChanged)="loadData()" (change)="loadData()" [(ngModel)]="from" placeholder="From"></app-date-edit>
    </div>
    <div fxFlex="30">
      <app-date-edit class="date-field"  (onChanged)="loadData()" (change)="loadData()" [(ngModel)]="to" placeholder="To"></app-date-edit>

    </div>
    <div fxFlex="40">
      <button color="primary" mat-raised-button (click)="loadData()">Refresh</button>
    </div>
  </div>

    <div fxLayout="row" style="">
    <div fxFlex="100">

      <div style="width: 100%; overflow-x: scroll;">
        <ngx-charts-area-chart-stacked
          [view]="view"
          [scheme]="colorScheme"
          [results]="multi"
          [gradient]="gradient"
          [xAxis]="showXAxis"
          [yAxis]="showYAxis"
          [legend]="showLegend"
          [showXAxisLabel]="showXAxisLabel"
          [showYAxisLabel]="showYAxisLabel"
          [xAxisLabel]="xAxisLabel"
          [yAxisLabel]="yAxisLabel"
          [animations]="animations"
          [xAxisTicks]="currentXAxisTicks"

          [customColors]="barCustomColors"

          (select)="onSelectGraph($event)"


        >
        </ngx-charts-area-chart-stacked>

        <br />
        <ng-container *ngIf="this.data">Interval: {{ this.data.intervalMinutes  }} minutes</ng-container>

      </div>

    </div>

  </div>




</mat-card>
